<template>
  <modal v-if="showModal" @close="close">
    <template slot="body">
      <div class="add-lesson__header" :style="{'backgroundColor': color ? color : '#fff'}">
        <h2>{{ name.length > 0 ? name : i18n[locale]['create_subject'] }}</h2>
        <div class="add-lesson__calendars">
          {{ showMasterCalendarName }}
        </div>
        <div class="add-lesson__header__tabs" v-if="editSubject && !showDbErrorText">
          <div class="add-lesson__header__tabs__tab" :class="{'tab--is-active': theActiveTab === 0}"
               @click="theActiveTab = 0">
            {{ i18n[locale].edit_subject }}
          </div>
          <div class="add-lesson__header__tabs__tab" :class="{'tab--is-active': theActiveTab === 1}"
               @click="theActiveTab = 1">
            {{ i18n[locale].activity }}
          </div>
          <div class="add-lesson__header__tabs__tab" :class="{'tab--is-active': theActiveTab === 2}"
               @click="theActiveTab = 2">
            {{ i18n[locale].deleted_lessons }}
          </div>
        </div>
      </div>
      <div class="add-lesson__form add-lesson__loading-container"
           v-if="isLoadingSchoolCalenders || isLoadingTheEditSubject">
        <Loader bgColor="#f6f9fc"></Loader>
      </div>
      <div class="add-lesson__form" v-else>
        <div class="db-error-div" v-if="showDbErrorText">
          <h2 class="text-explainer">{{ i18n[locale].can_not_find_subject }}</h2>
        </div>
        <template v-else>
          <div class="add-lesson__form__content" v-if="theActiveTab === 2">
            <SubjectFormLogDeletedEvents :subject="editSubject"></SubjectFormLogDeletedEvents>
          </div>
          <div class="add-lesson__form__content" v-if="theActiveTab === 1">
            <h2>{{ i18n[locale].latest_activity }}</h2>
            <SubjectFormLog :subject="editSubject"></SubjectFormLog>
          </div>
          <div class="add-lesson__form__content" v-if="theActiveTab === 0">
            <!--
            <div class="d-label-and-toggle">
              <div class="icon__bg-circle"
                   :content="i18n[locale]['out_of_school_desc']"
                   v-tippy="{
                  arrow: false,
                  animateFill: false,
                animation : 'shift-away',
                zIndex: '999999992',
                boundary: 'window'}">
                <span class="icon-question3"></span>
              </div>
              <label class="d-label">{{ i18n[locale]['out_of_school'] }}</label>
              <AppToggle :propOn="isAway" @changed="isAway = !isAway"></AppToggle>
            </div>
            -->
            <div :class="{'input-group__flex': isSchoolFromNorway}">
              <div class="input-group">
                <label>{{ i18n[locale]['subject_title'] }}</label>
                <input type="text" v-model="name" :placeholder="i18n[locale]['ex_subject']"
                       @keyup="removeErrors('name')"
                       ref="name"
                       :class="{'input--error': formErrors['name']}">
                <p class="input-error" v-if="formErrors['name']">{{ formErrors['name'][locale] }}</p>
              </div>
              <div class="input-group" style="max-width: 100px" v-if="isArbeidstidsplanActivated">
                <label>Årsramme</label>
                <select v-model.number="preparation" class="d-input__select">
                  <option v-for="prep in preparationOptionsForNorway" :key="prep">
                    {{ prep }}
                  </option>
                </select>
              </div>
              <div class="input-group" style="max-width: 100px" v-if="isSchoolFromNorway">
                <label>Fagkode</label>
                <input type="text" v-model.number="subjectCode"
                       @focus="selectAllOnFocus($event)">
              </div>
            </div>
            <div class="input-group" v-if="calendarType !== 'user'">
              <label><span class="icon-user"></span> {{ i18n[locale]['add_teacher'] }}</label>
              <DSelectCalendarIds itemType="user"
                                  :showTags="true"
                                  :preSelectedItems="userCalendarIds"
                                  :showCreateButton="false"
                                  @update="setSelectedUsers">
              </DSelectCalendarIds>
            </div>
            <div class="input-group">
              <label><span class="icon-location"></span> {{ i18n[locale]['add_room'] }}</label>
              <DSelectCalendarIds itemType="room"
                                  :preSelectedItems="roomCalendarIds"
                                  :showCreateButton="false"
                                  @update="setSelectedRooms">
              </DSelectCalendarIds>
            </div>
            <p class="text-link" @click="setIsPossibleToAddKlasses"
               v-if="!isPossibleToAddKlasses && isAllowedToAddKlasses">{{ i18n[locale]['add_klass'] }}?</p>
            <transition name="dropdown">
              <div class="input-group" v-if="isPossibleToAddKlasses">
                <label><span class="icon-calendar4"></span> {{ i18n[locale]['add_klass'] }}</label>
                <DSelectCalendarIds itemType="klass"
                                    :calendarId="calendarId"
                                    :showTags="true"
                                    :preSelectedItems="klassCalendarIds"
                                    :showCreateButton="false"
                                    @update="setSelectedKlass">
                </DSelectCalendarIds>
              </div>
            </transition>
            <p class="text-link" @click="setIsPossibleToAddClub"
               v-if="!isPossibleToAddClub && isAllowedToAddClub">{{ i18n[locale]['add_club'] }}?
            </p>
            <transition name="dropdown">
              <div class="input-group" v-if="isPossibleToAddClub">
                <label><span class="icon-calendar4"></span> {{ i18n[locale]['add_club'] }}</label>
                <DSelectCalendarIds itemType="club"
                                    :calendarId="calendarId"
                                    :showTags="true"
                                    :preSelectedItems="clubCalendarIds"
                                    :showCreateButton="false"
                                    @update="setSelectedClub">
                </DSelectCalendarIds>
              </div>
            </transition>
            <div class="input-group__flex">
              <div class="input-group">
                <label>{{ i18n[locale]['hours_in_school_year'] }}</label>
                <input type="number" ref="inputLessonCount" v-model.number="hours"
                       @focus="selectAllOnFocus($event)"
                       :class="{'input--error': formErrors['hours']}">
                <p class="input-error" v-if="formErrors['hours']">{{ formErrors['hours'][locale] }}</p>
              </div>
              <div class="input-group">
                <label>{{ i18n[locale]['standard_duration'] }}</label>
                <input type="number" v-model="defaultDuration" @focus="selectAllOnFocus($event)" :class="{'input--error': formErrors['defaultDuration']}">
                <p class="input-error"
                   v-if="formErrors['defaultDuration']">{{ formErrors['defaultDuration'][locale] }}</p>
              </div>
            </div>
            <div class="input-group">
              <label>{{ i18n[locale]['choose_color'] }}</label>
              <ColorPicker @changedColor="setSubjectColor"
                           :initialColor="color">
              </ColorPicker>
            </div>
            <!-- STUDENTS FOR TEST -->
            <div class="input-group" v-if="calendarType === 'klass' && klassStudents.length > 0">
              <label>{{ $t('vue2.students.students') }}</label>
              <StudentsOnSubject
                :calendarId="calendarId"
                :isNotEditSubject="isEditSubject"
                :studentCalendarIds="studentCalendarIds"
                @changed="setStudentCalendarIds"
              ></StudentsOnSubject>
            </div>
            <!-- SHOW SCHOOL IF USER HAS MULTIPLE SCHOOLS -->
            <div class="input-group" v-if="isShowSchool">
              <div><h3 v-if="!theSchoolForTheSubject">{{ activeSchool.name }}</h3>
                <h3 v-else>{{ theSchoolForTheSubject.name }}
                  <span class="small-text" v-if="theActiveSchoolYearForTheSubject">, {{
                    theActiveSchoolYearForTheSubject.name
                  }}</span></h3></div>
            </div>
            <div class="input-group" v-if="isShowSchoolYearSelector">
              <label>{{ i18n[locale]['choose_school_year'] }}</label>
              <ChangeSchoolYear :whiteTheme="true" style="width: 50%"></ChangeSchoolYear>
            </div>
            <div class="input-group">
              <label>{{ i18n[locale]['choose_subject_type'] }}</label>
              <SubjectTypePicker
                :calendarType="calendarType"
                :subjectType="subjectType"
                @change="selectSubjectType">
              </SubjectTypePicker>
            </div>
            <div class="edit-subject" v-if="editSubject">
              <div class="input-group input-group__submit">
                <div class="input-group__submit__left">
                  <button v-if="editSubjectCanBeDeleted"
                          class="hint--right bttn--warning"
                          :aria-label="i18n[locale]['delete_subject']"
                          @click="deleteEditSubject">
                    <span class="icon-bin"></span>
                  </button>
                  <div class="hint--right" v-else :aria-label="i18n[locale]['cannot_delete']">
                    <button class="bttn bttn--disabled">
                      <span class="icon-bin"></span>
                    </button>
                  </div>
                </div>
                <div class="input-group__submit__right">
                  <button class="do-bttn" @click="close">{{ i18n[locale]['cancel'] }}</button>
                  <button class="do-bttn do-bttn--submit" v-if="editSubject"
                          @click="updateSubject">{{ i18n[locale]['update_subject'] }}
                  </button>
                </div>
              </div>
            </div>
            <div class="input-group input-group__submit" v-else>
              <div class="input-group__submit__left">
              </div>
              <div class="input-group__submit__right">
                <button class="do-bttn" @click="close">{{ i18n[locale]['cancel'] }}</button>
                <button class="do-bttn do-bttn--submit" @click="createSubject">{{ i18n[locale]['create_subject'] }}</button>
              </div>
            </div>
          </div>
        </template>
        <SubjectFormDeleteSubjects
          v-if="subjectsWithSameName.length > 0"
          :subjectsWithSameName="subjectsWithSameName"
          @close="closeModalSubjectsWithSameName"
          @keep="keepExistingSubjects"
          @delete="deleteExistingSubjects">
        </SubjectFormDeleteSubjects>
      </div>
    </template>
  </modal>
</template>

<script>
import modal from './Modal'
import DSelectUser from '../DSelect/DSelectUsers'
import DSelectKlass from '../DSelect/DSelectKlass'
import ColorPicker from './ColorPicker'
import SubjectTypePicker from './SubjectFormSubjectType'
import DSelectCalendarIds from '../DSelect/DSelectCalsIds'
import SubjectFormLog from './SubjectFormLog'
import Loader from '../common/Loader'
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import StudentsOnSubject from '../Students/StudentsOnSubject'
import docendo from '../../docendo'
import SubjectFormDeleteSubjects from './SubjectFormDeleteSubjects'
import SubjectFormLogDeletedEvents from './SubjectFormLogDeletedEvents'
import AppToggle from '../common/AppToggle.vue'

const I18N = {
  da: {
    create_subject: 'Opret brik',
    hours_in_school_year: 'Klokketimer i skoleåret',
    add_teacher: 'Tilføj underviser',
    add_room: 'Tilføj lokale',
    add_klass: 'Tilføj klasse',
    add_club: 'Tilføj SFO',
    more_settings: 'Yderligere indstillinger',
    subject_title: 'Brikkens navn',
    standard_duration: 'Normal varighed (i minutter)',
    choose_class: 'Vælg klasse',
    choose_color: 'Vælg farve',
    choose_subject_type: 'Vælg briktype',
    ex_subject: 'Eks. Dansk',
    cancel: 'Annullér',
    update_subject: 'Opdatér brik',
    delete_subject: 'Slet brikken',
    edit_subject: 'Redigér brik',
    activity: 'Historik for brik',
    latest_activity: 'Seneste aktivitet',
    cannot_delete: 'Ikke muligt at slette, da brikken er skemalagt',
    choose_school_year: 'Vælg skoleår',
    can_not_find_subject: 'Kan desværre ikke vise brikken',
    deleted_lessons: 'Slettede lektioner',
    out_of_school_desc: 'Personalet vil fremgå som fraværende i vikardækningen, når denne er aktiveret.',
    out_of_school: 'Ude af huset'
  },
  en: {
    create_subject: 'Create course',
    hours_in_school_year: 'Hours in school year',
    add_teacher: 'Add teacher',
    add_room: 'Add room',
    add_klass: 'Add grade/group',
    add_club: 'Add club',
    more_settings: 'Advanced settings',
    subject_title: 'Subject title',
    standard_duration: 'Standard duration (in minutes)',
    choose_class: 'Choose grade/group',
    choose_color: 'Choose color',
    choose_subject_type: 'Choose course category',
    ex_subject: 'E.g. Math',
    cancel: 'Cancel',
    update_subject: 'Update course',
    delete_subject: 'Delete course',
    edit_subject: 'Edit course',
    activity: 'History',
    latest_activity: 'Activity',
    cannot_delete: 'Not possible to delete because the subject has lessons in a calendar',
    choose_school_year: 'Choose school year',
    can_not_find_subject: 'Unfortunately can not show the subject',
    deleted_lessons: 'Deleted lessons',
    out_of_school_desc: 'The staff will appear as absent in the substitute coverage when this is activated.',
    out_of_school: 'Out of school'
  },
  nb: {
    create_subject: 'Opprett fag',
    hours_in_school_year: 'Årstimetall',
    add_teacher: 'Legg til lærer',
    add_room: 'Legg til lokale',
    add_klass: 'Legg til klasse',
    add_club: 'Legg til SFO',
    more_settings: 'Flere innstillinger',
    subject_title: 'Navn på fag',
    standard_duration: 'Normal varighet (i minutter)',
    choose_class: 'Velg klasse',
    choose_color: 'Velg farge',
    choose_subject_type: 'Velg type',
    ex_subject: 'F.eks. Norsk',
    cancel: 'Angre',
    update_subject: 'Oppdater fag',
    delete_subject: 'Slett fag',
    edit_subject: 'Rediger fag',
    activity: 'Historikk',
    latest_activity: 'Aktivitet',
    cannot_delete: 'Ikke mulig å slette fordi faget har leksjoner i en kalender',
    choose_school_year: 'Velg skoleår',
    can_not_find_subject: 'Kan dessverre ikke vise faget',
    deleted_lessons: 'Slettede leksjoner',
    out_of_school_desc: 'Personalet vil vises som fraværende i vikaroversikten når denne er aktivert.',
    out_of_school: 'Utenfor skolen'
  }
}

export default {
  components: {
    AppToggle,
    StudentsOnSubject,
    ChangeSchoolYear,
    Loader,
    modal,
    ColorPicker,
    DSelectCalendarIds,
    DSelectUser,
    DSelectKlass,
    SubjectTypePicker,
    SubjectFormLog,
    SubjectFormDeleteSubjects,
    SubjectFormLogDeletedEvents
  },
  props: {
    initCalendarId: {
      default: null
    },
    showModal: {
      default: false
    },
    editSubject: {
      default: null
    },
    editSubjectId: {
      default: null
    },
    isInDCalendar: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      preparationOptionsForNorway: [741, 711, 664, 635, 606],
      preparation: null,
      theActiveTab: 0,
      calendarId: null,
      name: '',
      color: '#A0A5EF',
      defaultDuration: 45,
      hours: 0,
      subjectType: null,
      klassCalendarIds: [],
      userCalendarIds: [],
      roomCalendarIds: [],
      studentCalendarIds: [],
      clubCalendarIds: [],
      formErrors: [],
      isLoadingTheEditSubject: false,
      showDbErrorText: false,
      subjectCode: '',
      isPossibleToAddKlasses: false,
      subjectsWithSameName: [],
      updatedSubject: null,
      newSubject: null,
      isPossibleToAddClub: false,
      isAway: false
    }
  },
  computed: {
    isArbeidstidsplanActivated () {
      return this.$store.getters.isArbeidstidsplanActivated
    },
    schoolCountry () {
      return this.$store.getters.schoolCountry
    },
    isSchoolFromNorway () {
      return this.schoolCountry.toLowerCase() === 'no'
    },
    locale () {
      return this.$store.getters.locale
    },
    i18n () {
      let I18N_2 = I18N
      if (this.isKindergarten) {
        I18N_2['da']['add_teacher'] = 'Tilføj pædagog'
        I18N_2['da']['ex_subject'] = 'Eks. Carina'
        I18N_2['da']['hours_in_school_year'] = 'Timer i perioden'
        I18N_2['da']['choose_school_year'] = 'Vælg periode'
        I18N_2['da']['add_klass'] = 'Tilføj stue'
      }
      return I18N_2
    },
    schoolId () {
      return window.SCHOOL && window.SCHOOL.id ? window.SCHOOL.id : this.$route.params.school_id ? this.$route.params.school_id : null
    },
    isKindergarten () {
      return this.$store.getters.isKindergarten
    },
    isAllowedToAddKlasses () {
      return this.calendarType === 'klass' || (this.calendarType === 'user' && this.subjectType !== 'club')
    },
    isAllowedToAddClub () {
      return this.calendarType === 'club' || (this.calendarType === 'user' && this.subjectType === 'club')
    },
    editSubjectCanBeDeleted () {
      return this.editSubject && this.editSubject.can_delete || this.editSubject && this.editSubject.actual_hours === null
    },
    isEditSubject () {
      return !this.editSubject
    },
    klassStudents () {
      let students = this.allCalendarsInHash[this.calendarId] && this.allCalendarsInHash[this.calendarId].students ? this.allCalendarsInHash[this.calendarId].students : []
      return students.filter(studentId => this.allCalendarsInHash[studentId] && !this.allCalendarsInHash[studentId].archived_at)
    },
    user () {
      return this.$store.state.user
    },
    schoolYears () {
      return this.$store.state.schoolYears
    },
    activeSchool () {
      return this.$store.state.activeSchool
    },
    theSchoolForTheSubject () {
      let school = null
      if (this.editSubject && this.editSubject.school_id) {
        let schoolIdx = this.user.schools.findIndex(school => school.id === this.editSubject.school_id)
        if (schoolIdx > -1) {
          school = this.user.schools[schoolIdx]
        }
      }
      return school
    },
    theActiveSchoolYearForTheSubject () {
      let schoolYear = null
      if (this.editSubject && this.editSubject.school_year_id) {
        let schoolYearIdx = this.schoolYears.findIndex(schoolYear => schoolYear.id === this.editSubject.school_year_id)
        if (schoolYearIdx > -1) {
          schoolYear = this.schoolYears[schoolYearIdx]
        }
      }
      return schoolYear
    },
    activeSchoolYears () {
      return this.$store.state.activeSchoolYears
    },
    localActivatedSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    calendarType () {
      const calType = this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].type : 'user'
      return this.calendarId ? calType : 'klass'
    },
    isShowSchool () {
      let userHasMultipleSchools = this.user.schools.length > 1
      return this.calendarType === 'user' && userHasMultipleSchools
    },
    isShowSchoolYearSelector () {
      let hasMultipleActiveSchoolYears = this.activeSchoolYears.length > 1
      return !this.theActiveSchoolYearForTheSubject && hasMultipleActiveSchoolYears && this.calendarType === 'user'
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    klassCalendarInHash () {
      return this.$store.getters.allKlassCalendarsInHash
    },
    showMasterCalendarName () {
      return this.editSubject && this.allCalendarsInHash[this.editSubject.calendar_id] && this.allCalendarsInHash[this.editSubject.calendar_id].name ? this.allCalendarsInHash[this.editSubject.calendar_id].name : ''
    },
    activeSchoolYearId () {
      return this.editSubject && this.editSubject.school_year_id ? this.editSubject.school_year_id : this.localActivatedSchoolYear.id
    },
    arrOfAllSubjectCalendars () {
      let calIds = []
      this.userCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      this.roomCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      this.klassCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      this.studentCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      this.clubCalendarIds.forEach(calId => {
        calIds.push(calId)
      })
      return calIds
    },
    subjectsInKlassHash () {
      return this.$store.getters.subjectsInKlassHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    }
  },
  watch: {
    defaultDuration (val) {
      this.removeErrors('defaultDuration')
    }
  },
  methods: {
    setIsPossibleToAddKlasses () {
      this.isPossibleToAddKlasses = true
      this.$store.dispatch('readSubjects', this.activeSchoolYearId)
    },
    setIsPossibleToAddClub () {
      this.isPossibleToAddClub = true
      this.$store.dispatch('readSubjects', this.activeSchoolYearId)
    },
    setSelectedUsers (users) {
      this.userCalendarIds = users.map(user => user.id)
    },
    setSelectedRooms (rooms) {
      this.roomCalendarIds = rooms.map(room => room.id)
    },
    setSelectedKlass (klasses) {
      this.klassCalendarIds = klasses.map(klass => klass.id)
    },
    setSelectedClub (clubs) {
      this.clubCalendarIds = clubs.map(cal => cal.id)
    },
    addKlass (klass) {
      this.calendarId = klass.id
      this.removeErrors('calendarId')
    },
    removeKlass () {
      this.calendarId = null
    },
    setSubjectColor (val) {
      this.color = val
    },
    formValidation () {
      if (this.name.length < 1) {
        this.$set(this.formErrors, 'name', {
          da: 'Fag skal have et navn',
          en: 'Subjects must have a name',
          nb: 'Fag må ha et navn'
        })
      }
      if (this.hours < 0) {
        this.$set(this.formErrors, 'hours', {
          da: 'Skal være 0 eller højere',
          en: 'Must be zero or greater',
          nb: 'Må være 0 eller høyere'
        })
      }
      if (!this.isAValidDuration(this.defaultDuration)) {
        this.$set(this.formErrors, 'defaultDuration', {
          da: 'Skal være mellem 5 og 1440 minutter',
          en: 'Must be between 5 to 1440 minutes',
          nb: 'Må være mellom 5 og 1440 minutter'
        })
      }
      if (!this.calendarId) {
        this.$set(this.formErrors, 'calendarId', {
          da: 'Skal vælges. Du kan bagefter kopiere til andre',
          en: 'Must choose a class. It can later be copied',
          nb: 'Må velges. Du kan deretter kopiere til andres'
        })
      }
    },
    removeErrors (title) {
      this.$delete(this.formErrors, title)
    },
    createSubject () {
      this.formValidation()
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      this.newSubject = {
        name: this.name,
        color: this.color,
        calendarId: this.calendarId,
        defaultDuration: this.defaultDuration,
        preparation: this.preparation,
        hours: this.hours,
        subjectType: this.subjectType,
        calendarIds: this.arrOfAllSubjectCalendars,
        subjectCode: this.subjectCode,
        away: this.isAway
      }
      if (this.klassCalendarIds.length === 0) {
        this.$emit('createSubject', this.newSubject)
      } else {
        this.checkIfAddedKlassAlreadyHasSubjectWithSameName()
      }
    },
    updateSubject () {
      this.formValidation()
      if (Object.keys(this.formErrors).length > 0) {
        return
      }
      this.updatedSubject = {
        id: this.editSubject.id,
        name: this.name,
        color: this.color,
        calendarId: this.calendarId,
        defaultDuration: this.defaultDuration,
        preparation: this.preparation,
        hours: this.hours,
        subjectType: this.subjectType,
        calendarIds: this.arrOfAllSubjectCalendars,
        schoolId: this.theSchoolForTheSubject ? this.theSchoolForTheSubject.id : window.SCHOOL.id,
        schoolYearId: this.editSubject && this.editSubject.school_year_id ? this.editSubject.school_year_id : this.activeSchoolYear.id,
        subjectCode: this.subjectCode,
        away: this.isAway
      }
      if (this.klassCalendarIds.length === 0) {
        this.$emit('updateSubject', this.updatedSubject)
      } else {
        this.checkIfAddedKlassAlreadyHasSubjectWithSameName()
      }
    },
    deleteExistingSubjects () {
      this.subjectsWithSameName.forEach(subject => {
        this.$emit('deleteSubject', subject)
      })
      this.createOrUpdate()
    },
    keepExistingSubjects () {
      this.subjectsWithSameName = []
      this.createOrUpdate()
    },
    createOrUpdate () {
      if (this.editSubject) {
        this.$emit('updateSubject', this.updatedSubject)
      } else {
        this.$emit('createSubject', this.newSubject)
      }
    },
    closeModalSubjectsWithSameName () {
      this.subjectsWithSameName = []
    },
    checkIfAddedKlassAlreadyHasSubjectWithSameName () {
      let newKlassesAddedOnSubject = []
      this.klassCalendarIds.forEach(calId => {
        if (this.editSubject) {
          if (this.editSubject.calendar_ids.indexOf(calId) < 0) {
            newKlassesAddedOnSubject.push(calId)
          }
        } else {
          // It's a new subject so all klasses are new
          newKlassesAddedOnSubject.push(calId)
        }
      })
      if (newKlassesAddedOnSubject.length > 0) {
        newKlassesAddedOnSubject.forEach(calId => {
          // get all subjects for a klass
          const subjectIdsForKlass = this.subjectsInKlassHash[calId] ? this.subjectsInKlassHash[calId] : []
          const klassSubjects = subjectIdsForKlass.map(subjectId => {
            if (this.subjectsInHash[subjectId]) {
              return this.subjectsInHash[subjectId]
            }
          })
          klassSubjects.forEach(subject => {
            if (subject.name === this.name) {
              this.subjectsWithSameName.push(subject)
            }
          })
        })
        if (this.subjectsWithSameName.length === 0) {
          this.createOrUpdate()
        }
      } else {
        this.createOrUpdate()
      }
    },
    deleteEditSubject () {
      this.$emit('deleteSubject', this.editSubject)
    },
    clearForm () {
      this.theActiveTab = 0
      this.formErrors = []
      this.name = ''
      this.calendarIds = []
      this.hours = 0
      this.color = '#A0A5EF'
      this.setDefaultDuration()
      this.isLoadingTheEditSubject = false
      this.subjectCode = ''
      this.subjectsWithSameName = []
      this.updatedSubject = null
      this.newSubject = null
      this.preparation = ''
    },
    isAValidDuration (duration) {
      return /^-?[\d.]+(?:e-?\d+)?$/.test(duration) && duration > 4 && duration < 1441
    },
    close () {
      this.clearForm()
      this.$emit('close')
    },
    selectSubjectType (subjectType) {
      this.subjectType = subjectType
      // remove possible klasses from calendars array
      if (this.subjectType === 'other_tasks' || this.subjectType === 'other_stuff' || this.subjectType === 'club') {
        this.klassCalendarIds = []
        this.isPossibleToAddKlasses = false
      }
      if (this.subjectType !== 'club') {
        this.clubCalendarIds = []
        this.isPossibleToAddClub = false
      }
    },
    readTheEditSubject (editSubjectId) {
      docendo.showSubject(editSubjectId,
        success => {
          this.$emit('setTheEditSubject', success)
          if (success.status === 'error') {
            this.setErrorMessage()
            return
          }
          setTimeout(_ => {
            this.setTheEditSubject()
          }, 0)
          //
        }, failure => {
          console.log('failed')
        })
    },
    setErrorMessage () {
      this.showDbErrorText = true
      this.isLoadingTheEditSubject = false
    },
    selectAllOnFocus (evt) {
      setTimeout(_ => {
        evt.target.select()
      }, 0)
    },
    setTheEditSubject () {
      console.log('this.editSubject.away', this.editSubject)
      this.name = this.editSubject.name
      this.color = this.editSubject.color
      this.hours = this.editSubject.hours
      this.defaultDuration = this.editSubject.default_duration
      this.subjectType = this.editSubject.subject_type
      this.calendarId = this.editSubject.calendar_id
      this.subjectCode = this.editSubject.subject_code
      if (typeof this.editSubject.away !== 'undefined') {
        this.isAway = this.editSubject.away
      }
      if (this.editSubject.preparation) {
        this.preparation = this.editSubject.preparation * 1
      }
      if (this.editSubject.calendar_ids) {
        let klassCounter = 0
        this.editSubject.calendar_ids.forEach(calid => {
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'user') {
            this.userCalendarIds.push(calid)
          }
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'room') {
            this.roomCalendarIds.push(calid)
          }
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'club' && calid !== this.calendarId) {
            this.isPossibleToAddClub = true
            this.clubCalendarIds.push(calid)
          }
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'klass' && calid !== this.calendarId) {
            if (klassCounter === 0) {
              this.setIsPossibleToAddKlasses()
            }
            this.klassCalendarIds.push(calid)
            klassCounter++
          }
          if (this.allCalendarsInHash[calid] && this.allCalendarsInHash[calid].type === 'student') {
            this.studentCalendarIds.push(calid)
          }
        })
      }
      this.isLoadingTheEditSubject = false
    },
    setStudentCalendarIds (arr) {
      this.studentCalendarIds = arr
    },
    setDefaultDuration () {
      if (this.activeSchool && this.activeSchool.subject_default_duration) {
        this.defaultDuration = this.activeSchool.subject_default_duration
      } else {
        this.defaultDuration = 45
      }
    }
  },
  beforeMount () {
    if (this.initCalendarId) {
      this.calendarId = this.initCalendarId
    }
    if (this.editSubjectId) {
      this.isLoadingTheEditSubject = true
      this.readTheEditSubject(this.editSubjectId)
    }
    if (this.editSubject) {
      this.setTheEditSubject()
    }
    if (!this.editSubject && !this.editSubjectId) {
      this.setDefaultDuration()
    }
  },
  mounted () {
    if (!this.isInDCalendar && this.editSubject) {
      if (this.theActiveTab === 0) {
        setTimeout(_ => {
          this.$refs.inputLessonCount.focus()
        }, 500)
      }
      return
    }
    this.$nextTick(_ => {
      this.$refs.name.focus()
    })
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.add-lesson__header {
  position: relative;
  transition: background-color 0.4s;
  padding: 30px 20px;
  color: #ffffff;
  border-radius: 4px 4px 0 0;
}

.add-lesson__header > h2 {
  color: white;
  margin-top: 0;
}

.add-lesson__form {
  position: relative;
  padding: 1rem 2rem;
  overflow-y: scroll;
  max-height: calc(100vh - 10vh - 120px); /* 120px is modal header; 10vh is modal from vtop */
}

.add-lesson__header__tabs {
  position: absolute;
  z-index: 10;
  bottom: 0;
  right: 0;
  display: flex;
}

.add-lesson__header__tabs__tab {
  margin-right: 15px;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px 4px 0 0;
}

.add-lesson__header__tabs__tab.tab--is-active {
  background-color: #f6f9fc;
  color: #3e4450;
  font-weight: bold;
}

.add-lesson__form .input-group {
  padding-bottom: 1rem;
}

.add-lesson__calendars__calendar {
  margin-left: 0.5rem;
  position: relative;
}

.add-lesson__calendars__calendar:not(:last-child):after {
  content: ',';
  position: absolute;
  bottom: 0;
  right: -5px;
}

.input-group__submit {
  display: flex;
  justify-content: space-between;
}

.input-group__flex {
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: space-between;
  gap: 1rem;
}

.input-group__flex > div {
  flex: 1;
}

.input-group__flex > .flex-2 {
  flex: 2;
}

.input-group__flex > .flex-1 {
  flex: 1;
  margin-left: 1rem;
}

.input-group input, .input-group .d-select__input-look {
  background-color: #ffffff;
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
}

.lesson-count__edit {
  display: flex;
  align-items: center;
  max-width: 160px;
}

.lesson-count__edit input[type="number"] {
  margin: 0 0.25rem;
  text-align: center;
}

.button__delete-subject {
  color: var(--danger);
}

.expand-enter-active, .expand-leave-active {
  transition: transform 0.25s ease-in-out, opacity 0.25s ease-in-out;
}

.expand-enter, .expand-leave-to {
  transform: translateX(-0.5rem);
  opacity: 0;
}

.input-group label {
  letter-spacing: .075rem;
  text-transform: uppercase;
  font-size: 0.85rem;
  line-height: 1rem;
  font-weight: 700;
  display: block;
  color: #a2a3a6;
  margin-bottom: 6px;
}

.advanced-settings__link {
  cursor: pointer;
}

.advanced-settings__link:hover {
  text-decoration: underline;
}

.marg-1-right {
  margin-right: 1rem;
}

.bttn.bttn--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.bttn.bttn--disabled:active {
  background: #b34e4d;
}

.small-text {
  font-size: 12px;
}

.db-error-div {
  min-height: 20vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-link {
  color: var(--blue) !important;
  text-decoration: underline;
  margin-bottom: 1rem;
  cursor: pointer;
}

.input-group__submit__right {
  display: flex;
  gap: 1rem;
}

.d-label-and-toggle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #a2a3a6;
  height: 1rem;
}

.d-label-and-toggle label {
  margin-right: 0.5rem;
}


</style>



// WEBPACK FOOTER //
// CreateSubjectForm.vue?78caa1ec